import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=66983fff"
import script from "./previewModal.vue?vue&type=script&lang=js"
export * from "./previewModal.vue?vue&type=script&lang=js"
import style0 from "./previewModal.vue?vue&type=style&index=0&id=66983fff&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66983fff')) {
      api.createRecord('66983fff', component.options)
    } else {
      api.reload('66983fff', component.options)
    }
    module.hot.accept("./previewModal.vue?vue&type=template&id=66983fff", function () {
      api.rerender('66983fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/demageManage/previewModal.vue"
export default component.exports